import * as React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Typography,
  Paper,
  TableContainer,
} from "@mui/material";

interface InventoryRecord {
  id: string;
  airbagsCount: number;
  fullBinsCount: number;
  emptyBinsCount: number;
  createdAt: string;
  createdFrom: string;
}
const createdFromLabels: Record<string, string> = {
  MANUALLY_ADMIN: "Administrateur",
  MANUALLY_CLIENT: "Vous",
  ORDER: "Bon de commande",
};

export const InventoryTable: React.FC<{
  inventory: InventoryRecord[];
  page: number;
  rowsPerPage: number;
  total: number;
  onPageChange: (page: number, perPage: number) => void;
}> = ({ inventory, page, rowsPerPage, total, onPageChange }) => (
  <>
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Variation de votre stock
      </Typography>
      <TableContainer sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Airbags en vrac</TableCell>
            <TableCell align="center">Caisses pleines</TableCell>
            <TableCell align="center">Caisses vides</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="right">Ajouté par</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inventory.map((rec) => (
            <TableRow key={rec.id}>
              <TableCell align="center">{rec.airbagsCount}</TableCell>
              <TableCell align="center">{rec.fullBinsCount}</TableCell>
              <TableCell align="center">{rec.emptyBinsCount}</TableCell>
              <TableCell align="center">
                {new Date(rec.createdAt).toLocaleString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </TableCell>
              <TableCell align="right">
                {createdFromLabels[rec.createdFrom] || rec.createdFrom}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={total}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(_, newPage) => onPageChange(newPage, rowsPerPage)}
        rowsPerPageOptions={[5, 10, 25]}
        onRowsPerPageChange={(e) => {
          const r = parseInt(e.target.value, 10);
          onPageChange(0, r);
        }}
      />
      </TableContainer>
    </Paper>
  </>
);
